
import { useContext, useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { MenuItem, MenuList } from "@mui/material";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import parse from 'html-react-parser';

import styles from './MnuPage.module.css';
import MobiStyles from './MnuPageMobi.module.css';

import MenuItmesSection from './MenuItmesSection';
import ConnUrls from '../Connections/ConnectURL';

import { RestMenuContext } from '../Contexts/RestMenu_Context';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import { CurrentPContext } from '../Contexts/CurrentP_Context';
const MnuPage = (props) => {
    const navigate = useNavigate();
    const { mnuSec } = useParams();
    const [restMenu, setRestMenu, getMenu] = useContext(RestMenuContext)
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : MobiStyles);
    const [currentSection, setCurrrentSection] = useState(0);
    const [loading, setLoading] = useState(true);

    const [isSticky, setIsSticky] = useState(false);
    const menuItemsInHeadsRef = useRef(null);
    const mMenuTopWrapRef = useRef(null);

    useEffect(() => {
        setCurrentStyle(!mobiOrNot ? styles : MobiStyles)
    }, [mobiOrNot]);

    useEffect(() => {
        if (restMenu) {

            setLoading(false);
        } else {
            getMenu();
        }

    }, [restMenu, setRestMenu]);


    useEffect(() => {
        if (restMenu) {

            let theSect = parseInt(mnuSec) < restMenu.buisMenu.length ? parseInt(mnuSec) : 0;
            setCurrrentSection(theSect)
            let tempHomP = { ...restMenu, pageName: restMenu.buisMenu[theSect].DivName || restMenu.pageName || "נפוליאון תפריט" }
            setCurrentPage({ ...tempHomP, pageTYp: "" });
        }
    }, [mnuSec])

    useEffect(() => {

        let tempHomP = { ...restMenu, pageName: "נפוליאון תפריט" }
        setCurrentPage({ ...tempHomP, pageTYp: "" });
    }, [])

    useEffect(() => {
        const handleScroll = () => {
            if (mMenuTopWrapRef.current) {
                const fixedMenuTopWrapRef = mMenuTopWrapRef.current.offsetHeight + 70 +
                    parseFloat(window.getComputedStyle(mMenuTopWrapRef.current).marginBottom);

                if (window.scrollY > fixedMenuTopWrapRef &&
                    window.scrollY > menuItemsInHeadsRef.current.offsetTop) {

                    setIsSticky(true);
                } else {
                    setIsSticky(false);
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    const goToSectionMenu = (secIndx) => {
        setCurrrentSection(secIndx);
        navigate(`/Mnu/${secIndx}`);
        if (mMenuTopWrapRef.current) {

            let jumpInt = restMenu.buisMenu[secIndx].DivDescript ? 0 : 0;


            const fixedMenuTopWrapRef = mMenuTopWrapRef.current.offsetHeight + jumpInt +
                parseFloat(window.getComputedStyle(mMenuTopWrapRef.current).marginBottom);

            window.scrollTo({
                top: fixedMenuTopWrapRef,
                behavior: 'smooth' // Smooth scrolling behavior
            });
        }
        // navigate(`/Mnu/${secIndx}`);

    }



    return (
        !loading &&
        <div className={`${currnetStyle.MainMenuPage} regularPoint`}>
            <div ref={mMenuTopWrapRef} className={currnetStyle.MMenuTopWrap}>
                <div className={currnetStyle.MMenuTopImg}
                    style={{ backgroundImage: `url("${ConnUrls.servMediasUrl}${restMenu.menuStarters.mainImage}")` }}>
                    <div className={currnetStyle.MMenuTopTxtBlock}>
                        {restMenu.menuStarters &&
                            restMenu.menuStarters.mainContent &&
                            <div className={`${currnetStyle.MMenuInBlockTxt} animate__animated animate__zoomInDown regularPoint`}>
                                <div className={`${currnetStyle.theTxt}`}>
                                    {parse(`${restMenu.menuStarters.mainContent}`)}
                                </div>
                            </div>}
                    </div>
                </div>
            </div>

            {
                isSticky && !restMenu.buisMenu[currentSection].DivDescript &&
                <div className={`${currnetStyle.currentSecSmalltxt}`}>

                </div>
            }

            <div ref={menuItemsInHeadsRef} className={`${currnetStyle.theMaintop} ${isSticky ? currnetStyle.stickyMainTop : ''}`}>
                <div className={`${currnetStyle.menuItemsInHeads}`}>
                    <div className={currnetStyle.inMnuStrip}>
                        <div className={"seperatorDubleLine noMarginBottom"}></div>
                        <div className={`${currnetStyle.menuItemsInHeads} flexIt flex-Center`} style={{ justifyContent: "center" }}>
                            <div className={currnetStyle.fxPosWrap} style={{ justifyContent: "center" }}>
                                <Box sx={{ bgcolor: 'white', direction: 'rtl' }}>
                                    <Tabs
                                        value={currentSection}
                                        variant="scrollable"
                                        aria-label="תפריט"
                                        className={`${currnetStyle.tab} aviram`}
                                        style={{ display: "flex", justifyContent: "center" }}
                                    >
                                        {
                                            restMenu.buisMenu.map((mnuCatItem, index) => {
                                                return (
                                                    <Tab key={index}
                                                        onClick={() => goToSectionMenu(index)}
                                                        className={`${currnetStyle.tabClass}`}
                                                        style={{ color: "black" }}
                                                        label={mnuCatItem.DivName} />
                                                )
                                            })
                                        }
                                    </Tabs>
                                </Box>
                            </div>
                        </div>

                        <div className={"seperatorDubleLine noMarginTop"}></div>


                    </div>
                </div>
            </div>
            <div className={`${isSticky ? currnetStyle.addMarginSticky : ''}`}>
                {
                    restMenu.buisMenu[currentSection].DivDescript &&
                    <div className={`${currnetStyle.currentSecSmalltxt}`}>
                        {parse(`${restMenu.buisMenu[currentSection].DivDescript}`)}
                    </div>
                }
                <MenuItmesSection
                    theSectionHeader={parse(`${restMenu.buisMenu[currentSection].DivName}`)}
                    itemsOfSection={restMenu.buisMenu[currentSection].Products}
                    mnuItemMainImg={restMenu.mnuItemMainImg}
                />
            </div>
        </div >



    );
}

export default MnuPage;

